// Widget Scripts
import themeBackground from './js/widgets/themeBackground.js';
import * as mainFeature from './js/widgets/2-mainFeature/index.js';
import * as cardsSeo from './js/widgets/cards-seo/index.js';
import statsWidget from './js/widgets/8-statsWidget.js';
import renderSlideshows from './js/widgets/4-multiple-slideshows/index.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeBackground();

  if (globalThis.location.pathname === '/') {
    mainFeature.vimeoFeature();
    cardsSeo.customCards();
    statsWidget();
    cardsSeo.customSeoBlock();
    cardsSeo.seoCard();
    renderSlideshows();
  }
});
